import { Link } from 'react-router-dom';
import '../styles/page.css';
import { useEffect, useState } from 'react';
import { INoticeList } from '../../interface/notice';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Pagination from 'components/Pagination';

function Notice() {
  const [noticeList, setNoticeList] = useState<INoticeList[]>();
  const [searchNoticeTitle, setSearchNoticeTitle] = useState(''); // 공지사항 제목 검색

  // 페이징처리 관련
  const [currentPageNotice, setCurrentPageNotice] = useState<INoticeList[]>();
  const itemsPerPage = 10;
  const totalItems = noticeList?.length === 0 || undefined === noticeList ? 1 : noticeList?.length;

  /**
   * 검색 조건: 공지사항 제목 변경 시 이벤트
   */
  const handleChangeNoticeTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case 'searchNoticeTitle':
        setSearchNoticeTitle(event.target.value);
        break;

      default:
        break;
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    await fetch(`/notice/list?searchTitle=${searchNoticeTitle}`, {
      method: 'GET',
      headers: { 'Content-Type': 'applications/json' },
    })
      .then((response) => response.json())
      .then((result) => {
        setNoticeList(result);
      })
      .catch((error) => {
        console.error('공지사항 목록 조회 실패:', error);
      });
  };

  const handlePageChange = (page: number) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentPageNotice(noticeList?.slice(startIndex, endIndex));
  };

  useEffect(() => {
    // 초기 페이지 데이터 로드시키기
    handlePageChange(1);
  }, [noticeList]);

  useEffect(() => {
    AOS.init();
    handleSearch();
  }, []);

  return (
    <>
      <section id="notice-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              공지사항
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              TAKE의 최신 소식과 안내를 알려드립니다.
            </p>
          </div>
        </div>
      </section>

      <main id="notice">
        <div className="notice-container m-auto">
          <div className="notice-search-box">
            <div className="notice-search">
              <input
                inputMode="search"
                type="text"
                placeholder="검색"
                name="searchNoticeTitle"
                value={searchNoticeTitle}
                onChange={handleChangeNoticeTitle}
                onKeyDown={handleKeyDown}
              />
              <button className="notice-search-btn" type="button" onClick={handleSearch}>
                <img src="./images/ico-notice-search.svg" alt="검색버튼" />
              </button>
            </div>
          </div>
          <div className="notice-table">
            <div className="notice-table-thead">
              <div className="notice-table-td01">번호</div>
              <div className="notice-table-td02">제목</div>
              <div className="notice-table-td03">등록일</div>
            </div>
            {undefined !== currentPageNotice && currentPageNotice.length !== 0 ? (
              currentPageNotice.map((item, index) => (
                <div key={item?.boardSeq} className="notice-table-tbody">
                  <div className="notice-table-td01">{index + 1}</div>
                  <div className="notice-table-td02">
                    <Link to={`/notice-detail?boardSeq=${item?.boardSeq}`}>{item?.boardTitle}</Link>
                  </div>
                  <div className="notice-table-td03">{item?.regDt?.substring(0, 11)}</div>
                </div>
              ))
            ) : (
              <div className="notice-table-none">공지사항이 없습니다.</div>
            )}
          </div>

          {/* 페이지네이션 컴포넌트 */}
          <Pagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </div>
      </main>
    </>
  );
}

export default Notice;
